import { Switch, Route, Router } from 'react-router-dom';
import { Suspense } from 'react';
import ErrorBoundary from './components/errorBoundary/index';
import { history } from './history';
import { MODULENAME } from 'module-config';
import CommonModule from './modules/common-module';
import styles from './App.module.scss';

const App = () => {
  return (
    <ErrorBoundary history={history}>
      <Router history={history}>
        <Suspense fallback={<div />}>
          <Switch>
            <Route path="/newui" key="oe">
              <CommonModule name={MODULENAME.OEAPP} />
            </Route>
            <Route path="/ams" key="ams">
              <CommonModule name={MODULENAME.AGENTAPP} />
            </Route>
            <Route path="/hrms" key="hrsm">
              <CommonModule name={MODULENAME.HRMSAPP} />
            </Route>
            <Route path="/admin-panel" key="cif">
              <CommonModule name={MODULENAME.CIFAPP} />
            </Route>
            <Route path="/analytics" key="analytics">
              <CommonModule name={MODULENAME.ANALYTICSAPP} />
            </Route>
            <Route path="/chatbot" key="chatbot">
              <CommonModule name={MODULENAME.CHATBOTAPP} />
            </Route>
            <Route path="/" key="root">
              <div>
                <h1>Welcome to the GG App</h1>
                <h3>No route found for this path</h3>
              </div>
            </Route>
          </Switch>
        </Suspense>
      </Router>
    </ErrorBoundary>
  );
};

export default App;
